/**
 * Dictionnaires de traduction Français / Lingala pour Job Kongo.
 * Clé -> { fr, ln }. Le lingala utilisé est celui de Kinshasa (mélange usuel avec le français).
 */
export const TRANSLATIONS = {
  // ===== Navigation =====
  'nav.home': { fr: 'Accueil', ln: 'Ebandeli' },
  'nav.search': { fr: 'Rechercher', ln: 'Koluka' },
  'nav.messages': { fr: 'Messages', ln: 'Bansango' },
  'nav.dashboard': { fr: 'Tableau de bord', ln: 'Esika ya mosala' },
  'nav.dashboard.short': { fr: 'Tableau', ln: 'Mosala' },
  'nav.profile': { fr: 'Mon profil', ln: 'Profil na ngai' },
  'nav.profile.short': { fr: 'Profil', ln: 'Profil' },
  'nav.notifications': { fr: 'Notifications', ln: 'Bansango ya sika' },
  'nav.login': { fr: 'Se connecter', ln: 'Kokota' },
  'nav.signup': { fr: 'Créer un compte', ln: 'Kofungola konti' },
  'nav.logout': { fr: 'Déconnexion', ln: 'Kobima' },
  'nav.admin': { fr: 'Administration', ln: 'Administration' },
  'nav.how': { fr: 'Comment ça marche', ln: 'Ndenge esalaka' },
  'nav.trust': { fr: 'Confiance', ln: 'Confiance' },
  'nav.faq': { fr: 'FAQ', ln: 'Mituna' },
  'nav.ambassadors': { fr: 'Ambassadeurs', ln: 'Ba ambassadeurs' },
  'nav.payments': { fr: 'Paiements', ln: 'Mifuta' },

  // ===== Accueil =====
  'home.badge': { fr: 'Paiements sécurisés · Profils vérifiés', ln: 'Mifuta na kimia · Ba profils ya solo' },
  'home.title.1': { fr: 'Trouvez le bon', ln: 'Zwá' },
  'home.title.2': { fr: 'près de chez vous.', ln: 'ya malamu pene na yo.' },
  'home.subtitle': { fr: 'Plombiers, baby-sitters, profs, électriciens… des milliers de prestataires vérifiés, partout en RDC.', ln: 'Ba plombiers, ba baby-sitters, ba profs, ba électriciens… bato ya misala ya solo, na RDC mobimba.' },
  'home.search.placeholder': { fr: 'Que recherchez-vous ? (ex. plombier, coiffure...)', ln: 'Ozali koluka nini ? (ndakisa: plombier, coiffure...)' },
  'home.search.allCategories': { fr: 'Toutes catégories', ln: 'Ba catégories nyonso' },
  'home.search.allCities': { fr: 'Toutes villes', ln: 'Bingumba nyonso' },
  'home.search.button': { fr: 'Rechercher', ln: 'Koluka' },
  'home.stats.jobeurs': { fr: 'jobeurs vérifiés', ln: 'ba jobeurs ya solo' },
  'home.stats.jobs': { fr: 'jobs réalisés', ln: 'misala esilaki' },
  'home.stats.communes': { fr: 'communes couvertes', ln: 'ba communes' },
  'home.categories.title': { fr: 'Catégories populaires', ln: 'Ba catégories ya bato mingi' },
  'home.categories.subtitle': { fr: 'Choisissez le service dont vous avez besoin.', ln: 'Poná mosala oyo ozali na mposa na yango.' },
  'home.seeAll': { fr: 'Voir tout', ln: 'Talá nyonso' },
  'home.how.title': { fr: 'Comment ça marche', ln: 'Ndenge esalaka' },
  'home.how.subtitle': { fr: '3 étapes simples, avec confiance.', ln: 'Ba étapes 3 ya pɛtɛ, na confiance.' },
  'home.how.1.title': { fr: '1. Publiez', ln: '1. Bimisá mosala' },
  'home.how.1.desc': { fr: 'Décrivez votre besoin en 1 minute. C’est gratuit et sans engagement.', ln: 'Limbolá mposa na yo na minute 1. Ezali ofele.' },
  'home.how.2.title': { fr: '2. Choisissez', ln: '2. Poná' },
  'home.how.2.desc': { fr: 'Recevez des propositions de jobeurs vérifiés. Comparez, discutez.', ln: 'Zwá ba propositions ya ba jobeurs ya solo. Kokanisá, sololá.' },
  'home.how.3.title': { fr: '3. Réalisez en confiance', ln: '3. Salá na confiance' },
  'home.how.3.desc': { fr: 'Paiement sécurisé en séquestre. Libéré après validation.', ln: 'Lifuta ebombami na kimia. Ekobima sima ya validation.' },
  'home.urgent.title': { fr: 'Jobs urgents', ln: 'Misala ya lombangu' },
  'home.urgent.subtitle': { fr: 'Missions à réaliser sous 24h.', ln: 'Misala ya kosala na ngonga 24.' },
  'home.urgent.see': { fr: 'Voir', ln: 'Talá' },
  'home.featured.title': { fr: 'Jobeurs vedettes', ln: 'Ba jobeurs ya likolo' },
  'home.featured.subtitle': { fr: 'Nos prestataires les mieux notés.', ln: 'Bato ya misala oyo baleki malamu.' },
  'home.testimonials.title': { fr: 'Ils ont choisi Job Kongo', ln: 'Baponaki Job Kongo' },
  'home.cta.title': { fr: 'Prêt à commencer ?', ln: 'Osili komibongisa ?' },
  'home.cta.subtitle': { fr: 'Rejoignez la communauté Job Kongo. Publier une demande ou devenez jobeur en quelques minutes.', ln: 'Kotá na lisanga ya Job Kongo. Bimisá mposa na yo to komá jobeur na ba minutes moke.' },
  'home.cta.client': { fr: "J'ai un besoin", ln: 'Nazali na mposa' },
  'home.cta.jobeur': { fr: 'Devenir jobeur', ln: 'Kokoma jobeur' },

  // ===== Auth =====
  'auth.login.title': { fr: 'Content de vous revoir', ln: 'Esengo na komona yo lisusu' },
  'auth.login.subtitle': { fr: 'Connectez-vous à votre compte Job Kongo.', ln: 'Kotá na konti na yo ya Job Kongo.' },
  'auth.email': { fr: 'Email', ln: 'Email' },
  'auth.password': { fr: 'Mot de passe', ln: 'Mot de passe' },
  'auth.login.button': { fr: 'Se connecter', ln: 'Kokota' },
  'auth.login.loading': { fr: 'Connexion…', ln: 'Kokota…' },
  'auth.forgot': { fr: 'Mot de passe oublié ?', ln: 'Obosani mot de passe ?' },
  'auth.demo': { fr: 'Comptes de démonstration :', ln: 'Ba konti ya komeka :' },
  'auth.noAccount': { fr: 'Pas encore de compte ?', ln: 'Ozali nanu na konti te ?' },
  'auth.createAccount': { fr: 'Créer un compte', ln: 'Kofungola konti' },

  // ===== Mot de passe oublié =====
  'forgot.title': { fr: 'Mot de passe oublié', ln: 'Obosani mot de passe' },
  'forgot.subtitle': { fr: 'Récupérez votre compte en 3 étapes.', ln: 'Zwá konti na yo lisusu na ba étapes 3.' },
  'forgot.channel.label': { fr: 'Comment recevoir le code ?', ln: 'Okozwa code ndenge nini ?' },
  'forgot.channel.email': { fr: 'Par email', ln: 'Na email' },
  'forgot.channel.sms': { fr: 'Par SMS', ln: 'Na SMS' },
  'forgot.sendCode': { fr: 'Envoyer le code', ln: 'Kotinda code' },
  'forgot.code.label': { fr: 'Code reçu (6 chiffres)', ln: 'Code oyo ozwaki (mituya 6)' },
  'forgot.newPassword': { fr: 'Nouveau mot de passe', ln: 'Mot de passe ya sika' },
  'forgot.reset': { fr: 'Réinitialiser', ln: 'Kobongisa' },
  'forgot.backToLogin': { fr: 'Retour à la connexion', ln: 'Kozonga na kokota' },
  'forgot.demoBanner': { fr: 'Mode démo — votre code :', ln: 'Mode démo — code na yo :' },
  'forgot.success': { fr: 'Mot de passe réinitialisé ! Connectez-vous.', ln: 'Mot de passe ebongisami ! Kotá sikoyo.' },

  // ===== Notifications =====
  'notif.title': { fr: 'Notifications', ln: 'Bansango ya sika' },
  'notif.subtitle': { fr: 'SMS simulés — vos alertes devis et paiements.', ln: 'Ba SMS ya komeka — bansango ya devis mpe mifuta.' },
  'notif.empty': { fr: 'Aucune notification pour le moment.', ln: 'Nsango moko te sikoyo.' },
  'notif.markAll': { fr: 'Tout marquer lu', ln: 'Kotanga nyonso' },
  'notif.smsTag': { fr: 'SMS simulé', ln: 'SMS ya komeka' },

  // ===== Commun =====
  'common.loading': { fr: 'Chargement…', ln: 'Ezali koya…' },
  'common.send': { fr: 'Envoyer', ln: 'Kotinda' },
  'common.cancel': { fr: 'Annuler', ln: 'Kotika' },
  'common.accept': { fr: 'Accepter', ln: 'Kondima' },
  'common.reject': { fr: 'Refuser', ln: 'Koboya' },
  'common.save': { fr: 'Enregistrer', ln: 'Kobomba' },
  'common.jobeur': { fr: 'jobeur', ln: 'jobeur' },
  'common.language': { fr: 'Langue', ln: 'Monoko' },
};

export const LANGS = [
  { code: 'fr', label: 'FR', full: 'Français' },
  { code: 'ln', label: 'LN', full: 'Lingala' },
];
